module.exports = __webpack_public_path__ + "static/media/development_04.b014330e.png";